import { React } from '../../../Imports';
import { VideoEventResponse, VideoEventScoreResponse } from '$Generated/api';
import { VideoEventCard } from '../VideoEventCard/VideoEventCard';
import { IMultiselectFilterOptions } from '$Pages/VideoEvents/VideoEvents';
import { useRef } from 'react';

const InfiniteScroll: any = require('react-infinite-scroller');

interface IVideoEventCardListProps {
    items: VideoEventResponse[];
    onSelectVideoEvent: (eventId: string, goBack: boolean) => void;
    onFlagVideoEvent?: (eventId: number | undefined) => void;
    onDismissVideo?: (eventId: number | undefined) => void;
    onReopenEvent?: (eventid: number | undefined) => void;
    handleVideoPlayed?: (eventid: number | undefined) => void;
    loadNextPage: () => void;
    deleteVideoRecall?: (eventId: number) => void;
    morePagesToLoad: boolean;
    shrinkHeight: number;
    filters: IMultiselectFilterOptions;
    onUpdateFilters: (filters: IMultiselectFilterOptions) => void;
    isMobileView: boolean;
    toggleDeletePopup: (selectedId?: number) => void;
    toggleDismissPopup: (selectedId?: number) => void;
    deleteButtonDisabled: boolean;
    videoEventRatings?: VideoEventScoreResponse[] | undefined;
    isVideoEventsRedesign?: boolean;
}

const styles = require('./VideoEventCardList.scss') as {
    main: string;
    card: string;
    scrollWindow: string;
};

export const VideoEventCardList = (props: IVideoEventCardListProps) => {
    const scrollParentRef = useRef<HTMLDivElement | null>(null);

    return (
        <div
            className={styles.scrollWindow}
            ref={(ref) => (scrollParentRef.current = ref)}
            style={{ height: `calc(100vh - ${props.shrinkHeight + 40}px)` }}
        >
            <InfiniteScroll
                pageStart={1}
                loadMore={props.loadNextPage}
                hasMore={props.morePagesToLoad}
                loader={
                    <div key={'videoEventCardListloader'} className="loader">
                        Loading ...
                    </div>
                }
                useWindow={false}
                getScrollParent={() => scrollParentRef.current}
            >
                <div className={styles.main}>
                    {props.items.map((card: VideoEventResponse, idx: number) => (
                        <div className={styles.card} key={idx + 'card'}>
                            <VideoEventCard
                                videoEventStatus={card.videoEventStatus}
                                event={card}
                                onSelectVideoEvent={props.onSelectVideoEvent}
                                onFlagVideoEvent={props.onFlagVideoEvent}
                                handleVideoPlayed={props.handleVideoPlayed}
                                toggleDeletePopup={props.toggleDeletePopup}
                                deleteButtonDisabled={props.deleteButtonDisabled}
                                toggleDismissPopup={props.toggleDismissPopup}
                            />
                        </div>
                    ))}
                </div>
            </InfiniteScroll>
        </div>
    );
};
